<template>
  <div class="file-select">
    <Button type="primary" size="small" @click="handleSelect">{{ langMap.selectFile[lang] }}</Button>
    <input class="file-input" ref="fileRef" type="file" :accept="accept" @change="handleFileChange" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import langMap from '@/utils/language'

export default {
  props: {
    accept: {
      type: String,
      default: '.json,.txt'
    },
    title: {
      type: String,
      default: '选择文件'
    }
  },
  data() {
    return {
      langMap:langMap
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language
    })
  },
  methods: {
    handleSelect() {
      this.$refs.fileRef.click();
    },
    handleFileChange(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        this.$emit('change', files);
        event.target.value = '';
      }
    }
  }
}
</script>
<style lang="less" scoped>
.file-select {
  position: relative;
  display: inline-block;
}

.file-input {
  position: absolute;
  width: 0;
  opacity: 0;
  height: 0;
}
</style>